import { roundOfToTwoDigits, roundOfToTwoDigits2 } from '../numbers'

export const monthShotForm: Array<string> = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
]

export enum DateFormatTypes {
  YYYYMMDD = 'yyyymmdd',
  TIME_STAMP = 'timestamp',
  DAY_ONLY = 'dayonly',
  DATE_HYPHEN = 'datehyphen',
  DD_MM_YYYY = 'dd-mm-yyyy',
  DATE_STRING = 'datestring',
  DD_MMM_YYYY = 'DD MMM YYYY',
  MONTH_STRING = 'monthstring',
  MONTH_STRING_ISO = 'monthstringiso',
  DATE_MILIS = 'dateinmili',
  DATE_AM_PM = 'dateampm',
  YYYYMMDD_HH_MM_SS = 'datetime',
  DATE_ONLY = 'dateonly',
  DATE_LOCAL = 'datelocal',
  DATE_ONLY_WITHOUT_TIME = 'datewithouttime',
  DD_MMM_YYYY_FROM_YYYYMMDD = 'DD_MMM_YYYY_FROM_YYYYMMDD',
  DATE_STRING_TIME = 'DATE_STRING_TIME',
}

export const dateFormatter = (date: string | Date, type: DateFormatTypes): string => {
  if (typeof date === 'string' && type === DateFormatTypes.TIME_STAMP) {
    if (date?.length === 14) {
      return `${date.slice(6, 8)}-${date.slice(4, 6)}-${date.slice(0, 4)} at ${date.slice(8, 10)}:${date.slice(
        10,
        12,
      )}:${date.slice(12, 14)}`
    }

    if (date.length === 9) {
      return date
    }

    if (date.length > 14) {
      return `${date.slice(0, 10)} at ${date.slice(12, 20)}`
    }
  }

  if (date instanceof Date) {
    if (type === DateFormatTypes.YYYYMMDD) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${roundOfToTwoDigits(date.getDate())}` // DO NOT REMOVE - hyphen in between
    }
    if (type === DateFormatTypes.DAY_ONLY) {
      return `${date.getDate()} ${monthShotForm[date.getMonth()]}`
    }
    if (type === DateFormatTypes.DATE_HYPHEN) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${roundOfToTwoDigits(date.getDate())}`
    }
    if (type === DateFormatTypes.DD_MM_YYYY) {
      return `${roundOfToTwoDigits(date.getDate())}-${roundOfToTwoDigits(date.getMonth() + 1)}-${date.getFullYear()}`
    }
    if (type === DateFormatTypes.DATE_STRING) {
      return date.toLocaleDateString()
    }
    if (type === DateFormatTypes.MONTH_STRING_ISO) {
      return `${date.getDate()} ${monthShotForm[date.getMonth()]} ${date.getFullYear()}`
    }
    if (type === DateFormatTypes.DATE_STRING_TIME) {
      return `${date.toLocaleDateString()} ${roundOfToTwoDigits(date.getHours())}:${roundOfToTwoDigits(
        date.getMinutes(),
      )}:${roundOfToTwoDigits(date.getSeconds())}`
    }
  }

  return 'NA'
}

const getMonthName = {
  '01': 'Jan',
  '02': 'Feb',
  '03': 'Mar',
  '04': 'Apr',
  '05': 'May',
  '06': 'Jun',
  '07': 'Jul',
  '08': 'Aug',
  '09': 'Sep',
  '10': 'Oct',
  '11': 'Nov',
  '12': 'Dec',
}

export const toIsoDate = (date: Date): string => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()
}

export const fromIsoDate = (isoDateString: string): Date => {
  const isoDate = new Date(isoDateString)
  return new Date(isoDate.getTime() + isoDate.getTimezoneOffset() * 60000)
}

export const dateFormatter2 = (date: Date | string, type: DateFormatTypes): string => {
  // console.log({ type })

  // //As per new date format expected in API's
  // if (date instanceof Date && type === DateFormatTypes.YYYYMMDD_HH_MM_SS) {
  //   return newDateFormat(date)
  // }

  // FIXME: This type returns date with time am/pm
  if (typeof date === 'string' && type === DateFormatTypes.DATE_ONLY) {
    const dateObj: Date = new Date(`${date.replace(' ', 'T')}+05:30`) // .replace(' ', 'T') is required so it can work in diff js engines
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}, ${formatAMPM(dateObj)}`
  }

  // FIXME: This  returns only date without time am/pm
  if (typeof date === 'string' && type === DateFormatTypes.DATE_ONLY_WITHOUT_TIME) {
    const dateObj: Date = new Date(date.replace(' ', 'T')) // .replace(' ', 'T') is required so it can work in diff js engines
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.MONTH_STRING) {
    let dateObj: Date = new Date(+date)
    if (!dateObj.getDate()) {
      dateObj = new Date(date)
      if (!dateObj.getDate()) {
        return 'NA'
      }
    }
    return `${dateObj.getDate()} ${monthShotForm[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.MONTH_STRING_ISO) {
    const dateObj: Date = fromIsoDate(date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${dateObj.getDate()} ${monthShotForm[dateObj.getMonth()]} ${dateObj.getFullYear()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_AM_PM) {
    const dateObj: Date = new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    return `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()}, ${formatAMPM(dateObj)}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_LOCAL) {
    const formatedDate = new Date(date.replace(' ', 'T')).toLocaleString()
    return `${
      formatedDate.slice(6, 10) +
      '-' +
      formatedDate.slice(3, 5) +
      '-' +
      formatedDate.slice(0, 2) +
      formatedDate.slice(11)
    }`
  }

  if (typeof date === 'string' && type === DateFormatTypes.DATE_MILIS) {
    const year = date.substring(0, 4)
    const month = date.substring(4, 6)
    const day = date.substring(6, 8)
    const hour = date.substring(8, 10)
    const minute = date.substring(10, 12)
    const second = date.substring(12, 14)
    const formatedDate = new Date(+year, +month - 1, +day, +hour, +minute, +second)
    return `${formatedDate.getTime()}`
  }

  if (typeof date === 'string' && type === DateFormatTypes.TIME_STAMP) {
    const dateObj: Date = new Date(+date)
    if (!dateObj.getDate()) {
      return 'NA'
    }
    const fDate = `${roundOfToTwoDigits(dateObj.getDate())}-${roundOfToTwoDigits2(
      dateObj.getMonth(),
    )}-${dateObj.getFullYear()} at ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`
    return fDate
  }

  if (typeof date === 'string' && date.length === 10 && type === DateFormatTypes.DD_MMM_YYYY) {
    const dateString = date?.substring(0, 2)
    const monthString = getMonthName[date?.substring(3, 5)]
    const year = date?.substring(6, 10)
    return `${dateString} ${monthString} ${year}`
  }

  if (typeof date === 'string' && date.length >= 10 && type === DateFormatTypes.DD_MMM_YYYY_FROM_YYYYMMDD) {
    const dateString = date?.substring(6, 8)
    const monthString = getMonthName[date?.substring(4, 6)]
    const year = date?.substring(0, 4)
    return `${dateString} ${monthString} ${year}`
  }

  if (date instanceof Date) {
    if (type === DateFormatTypes.YYYYMMDD) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${roundOfToTwoDigits(date.getDate())} `
    }
    if (type === DateFormatTypes.DAY_ONLY) {
      return `${date.getDate()} ${monthShotForm[date.getMonth()]}`
    }
    if (type === DateFormatTypes.DATE_HYPHEN) {
      return `${date.getFullYear()}-${roundOfToTwoDigits(date.getMonth() + 1)}-${date.getDate()}`
    }
    if (type === DateFormatTypes.DATE_STRING) {
      return date.toLocaleDateString()
    }
  }

  return 'NA'
}

export const convertDateFormat = (date: string) => {
  return date.replace(/-/g, '/')
}

export const convertDateFormatWithHyphen = (date: string) => {
  return date.split('/').join('-')
}

export const getDateString = (timeStamp: any) => {
  try {
    // Months array
    var months_arr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    // Convert timestamp to milliseconds
    var date = new Date(timeStamp * 1000)
    return `${date.getDate()} ${months_arr[date.getMonth()]} ${date.getFullYear()}`
  } catch (err) {
    console.log('err: ', err)
  }
}

export const getDateString2 = (date: Date) => {
  const dateIN = date?.toLocaleDateString('en-GB')
  return dateIN.slice(0, 2) + ' ' + monthsMapper.get(dateIN.slice(3, 5) ?? '02') + ' ' + dateIN.slice(6)
}

const shortMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export function getCheckInDate(date: Date): string {
  const weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thr', 'Fri', 'Sat']
  return `${weekNames[date.getDay()]}, ${date.getDate()} ${shortMonths[date.getMonth()]}`
}
export function convertToTwoDigit(n: number) {
  return `0${n}`.slice(-2)
}

export function hyphenSplashSeparatedDate(date: Date, format?: string) {
  let formattedDate = ''
  switch (format) {
    case 'dd/mm/yyyy':
      formattedDate = `${convertToTwoDigit(date.getDate())}/${convertToTwoDigit(
        date.getMonth() + 1,
      )}/${date.getFullYear()}`
      break
    case 'DD-MM-YYYY':
    case 'dd-mm-yyyy':
      formattedDate = `${convertToTwoDigit(date.getDate())}-${convertToTwoDigit(
        date.getMonth() + 1,
      )}-${date.getFullYear()}`
      break
    case 'dd MMM':
      formattedDate = `${date.getDate()} ${shortMonths[date.getMonth()]}`
      break
    case 'dd-mm-yyyy hh:mm:ss':
      formattedDate = `${convertToTwoDigit(date.getDate())}-${convertToTwoDigit(
        date.getMonth() + 1,
      )}-${date.getFullYear()} ${convertToTwoDigit(date.getHours())}:${convertToTwoDigit(
        date.getMinutes(),
      )}:${convertToTwoDigit(date.getSeconds())}`
      break
    case 'yyyy-MM-dd hh:mm:ss':
      formattedDate = `${date.getFullYear()}-${convertToTwoDigit(date.getMonth() + 1)}-${convertToTwoDigit(
        date.getDate(),
      )} ${convertToTwoDigit(date.getHours())}:${convertToTwoDigit(date.getMinutes())}:${convertToTwoDigit(
        date.getSeconds(),
      )}`
      break
    default:
      formattedDate = `${date.getFullYear()}-${convertToTwoDigit(date.getMonth() + 1)}-${convertToTwoDigit(
        date.getDate(),
      )}`
      break
  }
  return formattedDate
}

export const formattedDate = (date) => {
  let d = date.getUTCDate().toString(),
    m = (date.getUTCMonth() + 1).toString(),
    y = date.getUTCFullYear().toString()
  let formatted = ''

  if (d.length === 1) {
    // pad to two digits if needed
    d = '0' + d
  }
  if (m.length === 1) {
    // pad to two digits if needed
    m = '0' + m
  }
  formatted = d + '-' + m + '-' + y
  // concatenate for output
  return formatted
}

export const dateConverter = (fullDate) => {
  let date = new Date(fullDate)

  let year = date.getFullYear().toString()
  let month = (date.getMonth() + 1).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  let day = date.getDate().toString()
  if (day.length === 1) {
    day = '0' + day
  }

  return day + '-' + month + '-' + year
}

export const convertEPOCHtoFormat = (epoch) => {
  let date = new Date(parseInt(epoch))

  let year = date.getFullYear().toString()
  let month = (date.getMonth() + 1).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  let day = date.getDate().toString()
  if (day.length === 1) {
    day = '0' + day
  }
  let hours = date.getHours().toString()
  if (hours.length === 1) {
    hours = '0' + hours
  }
  let minutes = date.getMinutes().toString()
  if (minutes.length === 1) {
    minutes = '0' + minutes
  }
  let seconds = date.getSeconds().toString()
  if (seconds.length === 1) {
    seconds = '0' + seconds
  }
  let miliseconds = String(date.getMilliseconds()).padStart(3, '0')

  return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds + '.' + miliseconds
}

export const epochConverter = (epoch: string) => {
  let date = new Date(parseInt(epoch, 10))

  let year = date.getFullYear().toString()
  let month = (date.getMonth() + 1).toString()
  if (month.length === 1) {
    month = '0' + month
  }
  let day = date.getDate().toString()
  if (day.length === 1) {
    day = '0' + day
  }

  return day + '/' + month + '/' + year + ''
}

export const monthsMapper = new Map([
  ['01', 'January'],
  ['02', 'February'],
  ['03', 'March'],
  ['04', 'April'],
  ['05', 'May'],
  ['06', 'June'],
  ['07', 'July'],
  ['08', 'August'],
  ['09', 'September'],
  ['10', 'October'],
  ['11', 'November'],
  ['12', 'December'],
])

export const getDateStringNum = (date: Date) => {
  const dateIN = date?.toLocaleDateString('en-GB')
  return dateIN.slice(0, 2) + ' ' + monthsMapper.get(dateIN.slice(3, 5) ?? '02') + ' ' + dateIN.slice(6)
}

export const getDateGLobal = (date: string) => {
  let month: string = '00'
  monthsMapper.forEach((key) => {
    if (monthsMapper.get(key) === date.slice(3, 6)) {
      month = key
    }
  })
  return month + '/' + date.slice(0, 2) + '/' + date.slice(7)
}

// dd month yyyy | hh:mm   // 20200915203748
export const getCustomDate = (date: string) => {
  const month = monthsMapper.get(date.slice(4, 6)) ?? 'NA'
  return `${date.slice(6, 8)} ${month} ${date.slice(0, 4)} | ${date.slice(8, 10)}:${date.slice(10, 12)}`
}

// gets current time of today  or midnigt for other dates
export const getTime = (date: Date) => {
  const today = new Date()
  if (
    today.getDate() === date.getDate() &&
    today.getMonth() === date.getMonth() &&
    today.getFullYear() === date.getFullYear()
  ) {
    const time = new Date(date.setHours(today.getHours(), today.getMinutes(), today.getSeconds())).getTime()
    return time
  }
  const toTime = new Date(date.setHours(23, 59, 59)).getTime()
  return toTime
}

export function YearMonthDayMinSec(date: Date): string {
  return (
    date.getFullYear() +
    '-' +
    ('0' + (date.getMonth() + 1)).slice(-2) +
    '-' +
    ('0' + date.getDate()).slice(-2) +
    ' ' +
    ('0' + date.getHours()).slice(-2) +
    ':' +
    ('0' + date.getMinutes()).slice(-2) +
    ':' +
    ('0' + date.getSeconds()).slice(-2)
  )
}

/*
 * It converts two digit year to four digit year
 * 20 to 2020
 */
export function convertYear(year: string) {
  if (year.length === 2) {
    const lYear = Number(year) > 50 ? '19' + year : '20' + year
    return lYear
  }
  return year
}

/*
 * It converts single digit month to two digit
 * 7 to 07
 * 10 to 10
 */
export function convertMonth(month: string) {
  return ('0' + month).slice(-2)
}

/**
 * It will convert the date to DD-MM-YYYY
 */
export function convertToDate(time: string) {
  const date = new Date(time)
  return `${roundOfToTwoDigits(date.getDate())}-${roundOfToTwoDigits(date.getMonth() + 1)}-${date.getFullYear()}`
}

export function getCurrentDate() {
  const currentTime = new Date()
  const currentOffset = currentTime.getTimezoneOffset()
  const ISTTime = new Date(currentTime.getTime() - currentOffset * 60000).toISOString()
  return ISTTime
}

export const formatAMPM = (date: Date): string => {
  let hours = date.getHours()
  let minutes = date.getMinutes()
  let ampm = hours >= 12 ? 'PM' : 'AM'
  hours = hours % 12
  hours = hours ? hours : 12
  const minutesString = minutes < 10 ? `0${minutes}` : `${minutes}`
  var strTime = hours + ':' + minutesString + ' ' + ampm
  return strTime
}

export const getHHMMSS = (date: Date) => {
  return (
    ('0' + date.getHours()).slice(-2) +
    ':' +
    ('0' + date.getMinutes()).slice(-2) +
    ':' +
    ('0' + date.getSeconds()).slice(-2)
  )
}

export const getLastMonthDateFromToday = (): string => {
  const now = new Date()
  let last30days = new Date(now.setDate(now.getDate() - 30))
  return last30days.toISOString().split('.')[0]
}

export function randomDate(start: Date, end: Date) {
  return new Date(start.getTime() + Math.random() * (end.getTime() - start.getTime()))
}

export const getRangeDate = (fromDate: Date, toDate?: Date): string => {
  if (toDate) {
    return `${dateFormatter(fromDate, DateFormatTypes.DAY_ONLY)} ${fromDate.getFullYear()} ${'-'} ${dateFormatter(
      toDate,
      DateFormatTypes.DAY_ONLY,
    )} ${toDate.getFullYear()}`
  }
  return `${dateFormatter(fromDate, DateFormatTypes.DAY_ONLY)} ${fromDate.getFullYear()}`
}

export enum DateType {
  FUTURE = 'FUTURE',
  PAST = 'PAST',
}

export enum CountDateIn {
  DAYS = 'DAYS',
  MONTH = 'MONTH',
  YEAR = 'YEAR',
}

export const getDateFromNumberOfDays = (
  count: number,
  type: DateType,
  countDateIn: CountDateIn = CountDateIn.DAYS,
): Date => {
  let date: any = new Date()
  if (type === DateType.FUTURE) {
    if (countDateIn === CountDateIn.DAYS) {
      date = new Date(date.setDate(date.getDate() + count))
    } else if (countDateIn === CountDateIn.MONTH) {
      date = new Date(date.setMonth(date.getMonth() + count))
    } else if (countDateIn === CountDateIn.YEAR) {
      date = new Date(date.setYear(date.getYear() + count))
    }
  } else if (type === DateType.PAST) {
    if (countDateIn === CountDateIn.DAYS) {
      date = new Date(date.setDate(date.getDate() - count))
    }
  }
  return date
}
